<template>
    <div :class="{'jo-fig':true,'rc_mode':layout == 'rc'}" :id="data.id">
      <div class="fig">
        <div v-for="item in this.data.graphics" :style="{'width': width(item), 'max-width': setMaxWidth()}">
          <img v-lazy="setImgSrc(item)" :data-width="width(item)" alt="fig"
               style="width: 30px;max-width: 100%" @click="showBigPic(item)"/>
        </div>
      </div>
      <div class="subcaption" v-if="this.data.subcaption!=''" v-bind:style="{'width': width(this.data.graphics[0]) + 'px', 'max-width':setMaxWidth() }">
        <p v-for="item in this.data.subcaption" v-bind:key="item.index"
           :style="{'width': Math.floor(100/data.subcaption.length) +'%','color' : ARTICLE.theme}">
          <component :is="'jo' + item2.name" v-for="item2 in item.label" v-bind:key="item2.index"
                     v-bind:data="item2.data"></component>&nbsp;<component :is="'jo' + item2.name" v-for="item2 in item.title" v-bind:key="item2.index"
                     v-bind:data="item2.data"></component>
        </p>
      </div>

        <div class="main-title" v-bind:style="{ 'width': width(this.data.graphics[0]) + 'px', 'max-width':setMaxWidth()}">
            <p v-if="mainCaption.length > 0" ref="title" class="fig-title" :style="{ 'color' : ARTICLE.theme }">
                <span v-for="(captionItem,index) in mainCaption" :key="index" :class="index!=0 ? 'blank-space':''">
                  <!--不在:key前面加一个独特的字符，会导致报错但不影响渲染，但console报错总是不好，所以这里加上两个前缀-->
                  <component :is="'jo' + item.name" v-for="(item,index) in captionItem.label" v-bind:key="'QAQ'+index"
                             v-bind:data="item.data"></component>&nbsp;&nbsp;<component :is="'jo' + item.name" v-for="(item,index) in captionItem.title" v-bind:key="'OvO'+index"
                             v-bind:data="item.data"></component></span>
            </p>
        </div>

        <div class="sub-title" v-bind:style="{ 'width': width(this.data.graphics[0]) + 'px', 'max-width':setMaxWidth() }">
            <p v-if="subCaption.length > 0" ref="subTitle" :style="{ 'color' : ARTICLE.theme }">
                <span v-for="(captionItem,index) in subCaption" :key="index">
                  <span v-if="index!=0">&nbsp;&nbsp;</span>
                  <component :is="'jo' + item.name" v-for="(item,index) in captionItem.label" v-bind:key="'QAQ'+index"
                             v-bind:data="item.data"></component>&nbsp;&nbsp;<component :is="'jo' + item.name" v-for="(item,index) in captionItem.title" v-bind:key="'OvO'+index"
                             v-bind:data="item.data"></component></span>
            </p>
        </div>
      <div class="table-note-div" v-if="this.data.note && this.data.note.length > 0"
           v-bind:style="{ 'width': width(this.data.graphics[0]) + 'px', 'max-width':setMaxWidth(),'margin':'0 auto' }">
        <div class="table-note" v-for="(noteItem,index) in this.data.note" :key="'note'+index">
          <!--<span v-if="noteItem.data[0].name && noteItem.data[0].name != 'vocab'" style="font-size: 1.2rem">{{noteItem.lang == 'zh' ? '注：' : 'NOTE:'}}</span>-->
          <p v-for="(item,index) in noteItem.data">
            <component :is="'jo' + item.name" v-bind:key="index" v-bind:data="item.data"
                       :hideVocab="hideVocab"></component>
            <span v-if="index != noteItem.data.length-1 && !hasColon(item)">{{noteItem.lang == 'zh' ? '；' : '; '}}</span>
          </p>
        </div>
      </div>
      <div v-if="showDownload() && this.data.graphics && this.data.graphics.length == 1" class="jo-download">
        <img src="../../../../assets/img/fig-download.png" alt="icon"/>
        <span>{{ARTICLE.defaultlang == 'zh' ? '下载' : 'Download'}}:&nbsp;</span>
        <span class="download-btn" v-if="this.data.graphics[0].print && this.data.graphics[0].print!= ''" @click="download(data.graphics[0].print)">{{ARTICLE.defaultlang == 'zh' ? '原图' : 'Full-size image'}}</span> |
        <span class="download-btn" v-if="this.data.graphics[0].big && this.data.graphics[0].big!= ''" @click="download(data.graphics[0].big)">{{ARTICLE.defaultlang == 'zh' ? '高精图' : 'High-res image'}}</span> |
        <span class="download-btn" v-if="this.data.graphics[0].small && this.data.graphics[0].small!= ''" @click="download(data.graphics[0].small)">{{ARTICLE.defaultlang == 'zh' ? '低精图' : 'Low-res image'}}</span>
      </div>
      <div v-else-if="showDownload() && this.data.graphics && this.data.graphics.length > 1" class="jo-download">
        <img src="../../../../assets/img/fig-download.png" alt="icon"/>
        <span>{{ARTICLE.defaultlang == 'zh' ? '下载' : 'Download'}}:&nbsp;</span>
        <span class="download-btn" @click="downloadAll('print')">{{ARTICLE.defaultlang == 'zh' ? '原图' : 'Full-size image'}}</span> |
        <span class="download-btn" @click="downloadAll('big')">{{ARTICLE.defaultlang == 'zh' ? '高精图' : 'High-res image'}}</span> |
        <span class="download-btn" @click="downloadAll('small')">{{ARTICLE.defaultlang == 'zh' ? '低精图' : 'Low-res image'}}</span>
      </div>
        <el-dialog width="inherit" top="0" custom-class="jo-bigPicDialog" :visible.sync="isShowBigPic">
            <img :src="this.currentGraphic.big" :style="{ 'max-height': picHeight + 'px', 'max-width': picWidth + 'px' }" alt="icon">
        </el-dialog>
    </div>
</template>

<script>
import joinlineformula from '../formula/inlineformula.vue'
import joinlinegraphic from './inlinegraphic.vue'

export default {
  components: {
    joinlineformula,
    joinlinegraphic
  },
  props: [
    'data',
    'isGroupImg'
  ],
  data () {
    return {
      subCaption:[],
      mainCaption:[],
      picHeight: 'inherit',
      picWidth: 'inherit',
      isShowBigPic: false,
      hideVocab:false,
      currentGraphic:this.data.graphics[0]
    }
  },
  created () {
      if (this.data.caption && this.data.caption.length > 0) {
        this.mainCaption.push(this.data.caption[0]);
        if (this.data.caption.length > 1) {
          this.subCaption.push(this.data.caption[1]);
        }
      }
    /*for (let item of this.data.caption){
      if (item.lang!==this.ARTICLE.defaultlang){
        this.subCaption.push(item);
      } else {
        this.mainCaption.push(item);
      }
    }*/
  },
  methods: {
    setImgSrc (item){
      if (this.layout === 'rc'){
        if (item.big && item.big !== ''){
          return item.big;
        }
        if (item.print && item.print !== ''){
          return item.print;
        }
        if (item.small && item.small !== ''){
          return item.small;
        }
      }
      if (item.big && item.big !== ''){
        return item.big;
      }
      if (item.small && item.small !== ''){
        return item.small;
      }
      if (item.print && item.print !== ''){
        return item.print;
      }
    },
    showBigPic (item) {
      if (this.layout === 'rc'){
        this.isShowBigPic = false;
        return
      }
      this.isShowBigPic = true
      this.currentGraphic = item
      this.picHeight = document.documentElement.clientHeight * 0.8
      this.picWidth = document.documentElement.clientWidth * 0.9

      if (navigator.userAgent.indexOf('MSIE 9.0')>0) {
        let img = new Image();
        img.src = this.currentGraphic.big;
        let imgWidth = img.width;
        let imgHeight = img.height;
        if (img.height > this.picHeight){
          this.picWidth = this.picHeight*img.width/img.height;
          imgHeight = this.picHeight;
          imgWidth = this.picWidth;
        }else if (img.width>this.picWidth){
          imgWidth = this.picWidth;
        }
        $('.jo-bigPicDialog').css({width:imgWidth+40, margin:'auto', 'margin-top':(document.documentElement.clientHeight-imgHeight-80)/2});
      }
    },
    setMaxWidth(){
      if (this.isGroupImg) return '80%';
      if (this.data.graphics.length===1) return '60%';
      return Math.floor(100/this.data.graphics.length) + '%';
    },
    width(graphic){
      /*毫米转化为像素*/
      let width = graphic.width * this.GLOBAL.deviceDPI.x / 25.4;
      return width * 1.6;
    },
    hasColon(item){
      let hasColon = false;
      if (item.name === 'p'){
        hasColon = this.hasColon(item.data[item.data.length-1]);
      } else if (item.name==='text'){
        if(item.data.lastIndexOf(';')===item.data.length-1 ||
          item.data.lastIndexOf('；')===item.data.length-1){
          return true
        }
      }
      return hasColon;
    },
    showDownload() {
      let userAgent = window.navigator.userAgent.toLowerCase();
      return this.layout== 'rc' && userAgent.match(/MicroMessenger/i) != 'micromessenger';
    },
    downloadAll(type){
      for (let i in this.data.graphics){
        if (type === 'big'){
          this.download(this.data.graphics[i].big)
        } else if (type === 'small') {
          this.download(this.data.graphics[i].small)
        } else if (type === 'print') {
          this.download(this.data.graphics[i].print)
        }
      }
    },
    download(url) {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('rv:11.0') > -1) {
        let iframe = document.createElement("iframe");
        iframe.src = url;
        iframe.id = 'IframeReportImg';
        iframe.style.display = 'none'
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", downloadImg);
        } else {
          iframe.onload = downloadImg;
        }
        document.body.appendChild(iframe);
        function downloadImg () {
          window.frames["IframeReportImg"].document.execCommand("SaveAs");
          document.body.removeChild(document.getElementById('IframeReportImg'));
        }

      } else {
        let image = new Image();
        let canvas = document.createElement('canvas');
        image.setAttribute('crossOrigin', 'anonymous')
        let title = '';
        if (this.$refs.title != undefined) {
          title = this.$refs.title.innerText;
        } else if (this.$refs.subTitle != undefined) {
          title = this.$refs.subTitle.innerText;
        }
        title = title.replace(/[.:\/\\]/g,'');
        image.onload = function () {
          canvas.width = image.width;
          canvas.height = image.height;
          /*资源中心传的图片链接没有后缀，不能直接使用a标签下载，需要先绘制图像*/
          let context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, image.width, image.height);
          canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
          canvas.toBlob((blob) => {
            let a = document.createElement('a');
            let event = new MouseEvent('click');
            a.href = window.URL.createObjectURL(blob);
            a.download = title;
            a.dispatchEvent(event);
            a.remove();
          }, "image");
        }
        image.onerror = function () {
//            tiff 图加载会失败，直接使用a标签下载
            console.log(title);
          let a = document.createElement('a');
          a.download = title + ".tif";
          let event = new MouseEvent('click');
          a.href = url;
          a.dispatchEvent(event);
          a.remove();
        }

        image.src = url

      }
    }
  },
  mounted(){
    if(navigator.userAgent.indexOf('rv:11.0')>-1 && this.isGroupImg){
      $('.jo-fig').css('display','block')
    }
  }
}
</script>

<style lang="scss" scoped>
    .jo-fig{
        background: #ffffff;
        text-align: center;
        margin: 0 auto;
      .fig{
        overflow:hidden;
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        div {
          & > img {
            margin-bottom: 0;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .jo-download {
        font-size: 1.4rem;
        color: #999999;
        text-align: right;
        padding-right: 20px;
        .download-btn{
          cursor: pointer;
        }
      }
        .jo-anchor{
            display:block;
            visibility:hidden;
        }
        .subcaption{
            display:block;
            justify-content:center;
            p{
              display:inline-block;
              width: 100%;
              text-align: center;
              span{
                /*display:table-cell;*/
              }
            }
        }
        .main-title, .sub-title, .subcaption {
          margin: 0 auto;
          min-width: 40%;
        }
        .subcaption p,.main-title p,.sub-title p{
            /*margin: 0;*/
            font-size: 1.2rem;
            line-height: 18px;
            text-align: center;
            color: #00a2af;
            text-indent: 0;
            font-weight:bold;
            margin-top: 10px;
        }
        /* 重写干扰部分 */
        .main-title .sup, .sub-title .sup{
            display: inline-block;
        }

        .table-note{
            text-align:left;
            margin: 0 auto;
            span{
                font-weight:bold;
              font-size: 1.2rem;
            }
            p{
                display:inline;
                margin: 0;
                font-size: 1.2rem;
                line-height: 18px;
                text-indent: 0;
            }
        }
      span.blank-space{
        margin-left: 5px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/fig/fig.vue